<template>
	<fieldset v-if="['remortgage'].indexOf(form.data.data.conveyancing.quote_type) > -1" class="fieldset">
		<div>
			<div>
				<legend><span class="beta heavy">Remortgage property details</span></legend>
			</div>
			<div class="input-group">
				<label><span>Case reference </span>
					<input v-model="form.data.data.conveyancing.remortgage.internal_reference" type="text">
					<div
						v-if="form.errors.get('data.conveyancing.remortgage.internal_reference')" class="error-block">
						<p v-html="form.errors.get('data.conveyancing.remortgage.internal_reference')"></p>
					</div>
				</label>
				<AddressLookup
					v-model="form.data.data.conveyancing.remortgage.address"
					:error="form.errors.get('data.conveyancing.remortgage.address')"
					:prefill="form.data.data.conveyancing.remortgage.address"
					class="fieldset-section"
					fieldId="remortgage-property-address"
					label="Remortgage property address"/>
				<label><span>Remortgage property price </span>
					<div
						v-if="form.errors.get('data.conveyancing.remortgage.property_price')"
						class="error-block">
						<p v-html="form.errors.get('data.conveyancing.remortgage.property_price')"></p>
					</div>
					<div>
						<money v-model="form.data.data.conveyancing.remortgage.property_price"/>
					</div>
				</label>
				<label><span>Number of people involved </span>
					<div
						v-if="form.errors.get('data.conveyancing.remortgage.number_of_people')"
						class="error-block">
						<p v-html="form.errors.get('data.conveyancing.remortgage.number_of_people')"></p>
					</div>
					<div>
						<select v-model="form.data.data.conveyancing.remortgage.number_of_people">
							<option disabled selected value="">—</option>
							<option value="1">1</option>
							<option value="2">2</option>
							<option value="3">3</option>
							<option value="4">4</option>
						</select>
					</div>
				</label>
				<label><span>Which lender is the mortgage with? </span>
					<div v-if="form.errors.get('data.conveyancing.remortgage.lender')" class="error-block">
						<p v-html="form.errors.get('data.conveyancing.remortgage.lender')"></p>
					</div>
					<div>
						<select
							v-model="form.data.data.conveyancing.remortgage.lender"
							:disabled="isDisabled(form.data.data.conveyancing.remortgage.mortgage)">
							<option :value="null" selected>Unknown</option>
							<option
								v-for="(lender, lenderIndex) in form.options.lenders" :value="lender.id"
								v-html="lender.name"/>
						</select>
					</div>
				</label>
				<label><span>Is the property Leasehold? </span>
					<div
						v-if="form.errors.get('data.conveyancing.remortgage.leasehold')"
						class="error-block">
						<p v-html="form.errors.get('data.conveyancing.remortgage.leasehold')"></p>
					</div>
					<select v-model="form.data.data.conveyancing.remortgage.leasehold">
						<option :value="false">No</option>
						<option :value="true">Yes</option>
					</select>
				</label>
				<label><span>Shared ownership? </span>
					<select v-model="form.data.data.conveyancing.remortgage.shared_ownership">
						<option disabled value="">—</option>
						<option :value="true">Yes</option>
						<option :value="false">No</option>
					</select>
				</label>
				<label><span>Transfer of equity? </span>
					<select v-model="form.data.data.conveyancing.remortgage.transfer_of_equity">
						<option disabled value="">—</option>
						<option :value="true">Yes</option>
						<option :value="false">No</option>
					</select>
				</label>
			</div>
		</div>
	</fieldset>
</template>
<script>
import hasFormFields from "../../mixins/hasFormFields";
import AddressLookup from "./fields/AddressLookup.vue";

export default {
	components: {
		AddressLookup,
	},
	mixins: [hasFormFields],

	props: {
		form: {
			required: true,
			type: Object,
		},
	},
};
</script>
